"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "el-tree-select",
    class: _vm.selectClass
  }, [_c("el-select", _vm._b({
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    ref: "select",
    staticClass: "el-tree-select-input",
    style: _vm.styles,
    attrs: {
      disabled: _vm.disabled,
      "popper-class": "select-option",
      "popper-append-to-body": false,
      filterable: false,
      multiple: _vm.selectParams.multiple,
      title: _vm.labels
    },
    on: {
      "remove-tag": _vm._selectRemoveTag,
      clear: _vm._selectClearFun,
      focus: _vm._popoverShowFun
    },
    model: {
      value: _vm.labels,
      callback: function ($$v) {
        _vm.labels = $$v;
      },
      expression: "labels"
    }
  }, "el-select", _vm.selectParams, false)), _c("el-popover", {
    ref: "popover",
    staticClass: "treepopover",
    attrs: {
      placement: _vm.placement,
      "popper-class": _vm.popperClass,
      width: _vm.width,
      trigger: "click"
    },
    on: {
      "after-leave": _vm._hidePopover
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_vm.treeParams.filterable ? _c("el-input", {
    staticClass: "input-with-select mb10",
    attrs: {
      placeholder: _vm.treeParams.placeholder || "搜索",
      size: "medium"
    },
    model: {
      value: _vm.keywords,
      callback: function ($$v) {
        _vm.keywords = $$v;
      },
      expression: "keywords"
    }
  }) : _vm._e(), _c("el-scrollbar", {
    staticClass: "is-empty",
    attrs: {
      tag: "div",
      "wrap-class": "el-select-dropdown__wrap",
      "view-class": "el-select-dropdown__list"
    }
  }, [_c("el-tree", _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.data.length > 0,
      expression: "data.length > 0"
    }],
    ref: "tree",
    attrs: {
      data: _vm.data,
      "node-key": _vm.propsValue,
      draggable: false,
      "current-node-key": _vm.ids.length > 0 ? _vm.ids[0] : "",
      "show-checkbox": _vm.selectParams.multiple,
      "filter-node-method": _vm._filterFun,
      "render-content": _vm.treeRenderFun
    },
    on: {
      "node-click": _vm._treeNodeClickFun,
      check: _vm._treeCheckFun
    }
  }, "el-tree", _vm.treeParams, false)), _vm.data.length === 0 ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v("暂无数据")]) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;